
var navigation = (function () {

	function mainNavActions() {
		let $nav = $('header .navbar');
		let prevScrollTop = 0;
		let isMobile = window.outerWidth < 450;

		$(document).scroll(function () {
			let scrollTop = $(this).scrollTop();
			$nav.toggleClass('scrolled', scrollTop > $nav.height());

			if (isMobile) {
				if (scrollTop < prevScrollTop) {
					$('header .navbar').addClass('fixed-top');
				} else {
					$('header .navbar').removeClass('fixed-top');
				}
			}
			prevScrollTop = scrollTop;
		});

		$('.navbar-collapse', $nav).on('hidden.bs.collapse', function () {
			$('header .navbar').removeClass('expanded');
		});

		$('.navbar-collapse', $nav).on('show.bs.collapse', function () {
			$('header .navbar').addClass('expanded');
		});

		$('.nav-link.dropdown-toggle').on('show.bs.dropdown', function () {
			$nav.addClass('open');
		});

		$('.nav-link.dropdown-toggle').on('hide.bs.dropdown', function () {
			$nav.removeClass('open');
		});
	}

	function footerActions() {
		$('#footer-open').on('show.bs.collapse', function () {
			$('.copyright p, .badges > div', '.mini-footer').fadeOut(function () {
				$(document).scrollTop(9999999);
				$('#open-footer').text('Hide full footer').addClass('open');
			});
		});

		$('#footer-open').on('hidden.bs.collapse', function () {
			$('#open-footer').text('Show full footer').removeClass('open');
			$('.copyright p, .badges > div', '.mini-footer').fadeIn();
		});
	}
	function setMobileMenuAtPosition() {
		var activeDepth = $('.menu.active:last').parents('.menu').length;
		$('.mobile-menu .offcanvas-body').scrollLeft(activeDepth * $(window).outerWidth());
	}

	function mobileMenuSetup() {

		$('.mobile-main-menu [data-toggle="sub-menu"]').on('click', function(evt) {
			evt.preventDefault();
			let $parent = $(this).parents('.menu:first');
			$('.sub-menu', $parent).removeClass('active'); 
			$($(this).data('target')).addClass('active');
			$('.mobile-menu .offcanvas-body').animate({ 'scrollLeft': $('.mobile-menu .offcanvas-body').scrollLeft() + $(window).outerWidth() });
			if ($('.menu.active:last').parents('.menu').length > 0) {
				$('.mobile-menu').addClass('open');
			}
		});

		$('.mobile-main-menu .sub-menu-back').on('click', function(evt) {
			evt.preventDefault();
			let $that = $(this);
			$('.nav-item').removeClass('active');
			$('.mobile-menu .offcanvas-body').animate({ 'scrollLeft': $('.mobile-menu .offcanvas-body').scrollLeft() - $(window).outerWidth() }, function () {
				$that.parents('.menu:first').removeClass('active').removeClass('open');
				let $parent = $that.parents('.menu:first');
				$('.sub-menu', $parent).removeClass('active');
				if ($('.menu.active:last').parents('.menu').length == 0) {
					$('.mobile-menu').removeClass('open');
				}
			});			
		});
	}

	return {
		init: function () {
			$(function () {
				mainNavActions();
				footerActions();
				mobileMenuSetup();
				// Hack for iOs as it doesn't seem abale to scroll properly without resetting to 0 first
				$('.mobile-menu .offcanvas-body').scrollLeft(0);
				window.setTimeout(setMobileMenuAtPosition, 500);
			});
		}
	};
})();

export var navigation;